import { grprService } from '@/api/grpr-service'

export const pesquisarParcelamento = async (context, payload) => {
  context.commit('setLoadingParcelamento', true)
  const response = await grprService.pesquisarParcelamento(payload)

  context.commit('setLoadingParcelamento', false)
  return response
}
